'use client';

import Image from 'next/image';

import { getDotcmsImageURL } from '@/app/utils/getDotcmsImageURL';
import TagList from '@/components/shared/TagList';

export function CaseStudyHeader({ thumbnailAlt, title, image, heading, industry, headerImage }) {
    const industries = industry?.categories?.map((item) => item.name);
    const tags = (industries ?? []).map((ind) => ({
        text: ind,
        fontColor: 'text-white',
        bgColor: 'bg-blue-600'
    }));

    const heroSrc =
        image || headerImage
            ? getDotcmsImageURL({ src: headerImage ?? image })
            : '/assets/circles-dots.svg';

    return (
        <div className="relative min-h-[440px] w-full overflow-hidden md:h-[70vh] md:max-h-[600px] md:min-h-[400px]">
            {/* Blurred background */}
            <Image
                src={heroSrc}
                fill
                priority
                quality={60}
                sizes="100vw"
                className="scale-110 object-cover blur-2xl"
                alt=""
                aria-hidden="true"
            />

            {/* Gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-blue-700 to-blue-700/20" />

            {/* Content */}
            <div className="absolute inset-0 flex items-end pb-10 md:pb-14">
                <div className="container flex flex-col-reverse gap-4 sm:flex-row sm:items-end sm:justify-between sm:gap-6">
                    {/* Title and tags */}
                    <div className="flex w-full flex-col gap-3 md:w-2/3">
                        <TagList tags={tags} />
                        <h1 className="text-balance text-2xl font-bold leading-tight text-white sm:text-3xl md:text-5xl">
                            {heading}
                        </h1>
                    </div>

                    {/* 16:9 image card */}
                    <div className="relative aspect-video w-full shrink-0 overflow-hidden rounded-xl shadow-2xl sm:w-[400px] md:w-[540px]">
                        <Image
                            src={heroSrc}
                            fill
                            priority
                            quality={85}
                            sizes="(max-width: 768px) calc(100vw - 32px), 40vw"
                            className="object-cover"
                            alt={thumbnailAlt || title || 'Case study image'}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
